import React from 'react';
import { Outlet } from 'react-router-dom';
import Container from './Container';
import AppBarSpacer from './AppBarSpacer';
import ResponsiveAppBar from './AppBar';
import Footer from './Footer';
import WhatsAppFixedButton from '../components/common/WhatsAppFixedButton';
import { CssBaseline } from '@mui/material';

interface LayoutProps {
}

const Layout: React.FC<LayoutProps> = ({ }) => {
    return (
        <>
            <CssBaseline />
            <ResponsiveAppBar />
            <AppBarSpacer />
            <Container>
                <Outlet />
            </Container>
            <WhatsAppFixedButton />
            <Footer />
        </>
    )
}

export default Layout;